export class SecretaryAlreadyLinkedError extends Error {
  constructor() {
    super('Esta secretária já está vinculada')
    this.name = 'SecretaryAlreadyLinkedError'
  }
}
